<template>
  <!-- eslint-disable vue/no-mutating-props -->
  <div class="c-form-item-org">
    <el-cascader
      ref="cascaderRef"
      v-bind="cascaderAttrs"
      :modelValue="innerModelValue"
      :disabled="disabled"
      :props="cascaderProps"
      :options="orgOptions"
      @change="handleChange"
    ></el-cascader>
  </div>
</template>

<script lang="ts">
export default { inheritAttrs: false }
</script>

<script setup lang="ts">
import { _, computed, watch, ref, useAttrs, onMounted, useCurrentAppInstance } from '@zto/zpage'
import { getOrgsRef, loadOrgs, getOrgData } from '../../../utils/org'

import type { GenericObject } from '@zto/zpage'

const props = withDefaults(
  defineProps<{
    model: GenericObject
    props: Array<any>
    disabled: boolean
    // multiple?: boolean // 暂不支持多选
    labelProps?: Array<any>
    propsConfig?: Record<string, any>
  }>(),
  {
    disabled: false
  }
)

const attrs = useAttrs()

const app = useCurrentAppInstance()

const cascaderRef = ref<any>()

const innerModelValue = ref<any>([])

const orgOptions = computed(() => getOrgsRef().value)
console.log('orgOptions===', orgOptions)

const cascaderProps = computed(() => {
  return {
    label: 'label',
    value: 'value',
    // multiple: props.multiple === true,
    ...props.propsConfig
  }
})

const cascaderAttrs = computed(() => {
  return {
    collapseTags: true,
    placeholder: '请选择',
    separator: '-',
    ...attrs,
    props: [
      {
        label: 'label',
        value: 'value',
        // multiple: props.multiple === true,
        ...props.propsConfig
      }
    ]
  }
})

watch( // 为了修复重置的时候时间显示不消失的问题
  () => props.model.allId,
  () => {
    if (!props.model.allId) {
      innerModelValue.value = []
    }

    props.props.forEach((it: any) => {
      innerModelValue.value.push(props.model[it])
    })
  },
  { immediate: true }
)

// watch(
//   () => props.model.provinceIdList,
//   () => {
//     if (!props.model.provinceIdList) {
//       innerModelValue.value = []
//     }

//     props.props.forEach((it: any) => {
//       innerModelValue.value.push(props.model[it])
//     })
//   }
// )

onMounted(async () => {
  await loadOrgs(app)
})

// 修改时触发
function handleChange(vals: any) {
  const valsData = (vals || []).map((it: string) => {
    return getOrgData(it)
  })

  props.props.forEach((it: any, index: number) => {
    props.model[it] = (valsData[index] || {})[cascaderProps.value.value]
  })

  // 获取值对应的label
  if (props.labelProps?.length) {
    props.labelProps.forEach((it: any, index: number) => {
      props.model[it] = (valsData[index] || {})[cascaderProps.value.label]
    })
  }
}
</script>
